import { 
  // createAsyncThunk, 
  createSlice } from '@reduxjs/toolkit';

// project import
// import axios from 'utils/axios';

// types
import { UserDetails } from 'types/usertypes';

// initial state
const initialState: UserDetails = {
  userName: "",
  userType: "",
  firstName: "",
  lastName: "",
  hotelDate: "",
  email: "",
  shiftStatus: "",
  companysLogo: "",
  companysAddress: "",
  companysEmail: "",
  licenseDetails: {
      expiryDate: "",
      leftOverDays: "",
      message: "",
      renewedOn: ""
  }
};

// ==============================|| SLICE - MENU ||============================== //

// export const fetchMenu = createAsyncThunk('', async () => {
//   const response = await axios.get('/api/userDetails/dashboard');
//   return response.data;
// });

const userDetails = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {
    fullname(state, action) {
      state.fullname = action.payload.fullname;
    },
    hotelDate(state, action) {
      state.hotelDate = action.payload.hotelDate;
    },
    userDetailsData(state, action) {
      console.log("\n\t Auth reducer-users: ", action.payload)
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      // state.licenseDetails = action.payload.licenseDetails;
      state.userName = action.payload.userName;
      state.userType = action.payload.userType;
      state.email = action.payload.email;
      // state.hotelDate = action.payload.hotelDate;
    },
  },

  // extraReducers(builder) {
  //   builder.addCase(fetchMenu.fulfilled, (state, action) => {
  //     state. = action.payload.dashboard;
  //   });
  // }
});

export default userDetails.reducer;

export const { fullname, hotelDate, userDetailsData } = userDetails.actions;
